import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';
import SettingType from '@settings/models/setting-type.enum';
import GetSettingDto from '@settings/models/dto/get-setting.dto';
import UpdateSettingDto from '@settings/models/dto/update-setting.dto';

export const getSettingByType = async (
  settingType: SettingType,
): Promise<AxiosResponse<GetSettingDto[]>> => {
  return await axiosClient.get(EndPoints.setting.getSettingByType(settingType));
};

export const updateSettings = async (
  payload: UpdateSettingDto[],
): Promise<AxiosResponse<GetSettingDto[]>> => {
  return await axiosClient.put(EndPoints.setting.updateSettings(), payload);
};
